/* eslint-disable react/no-array-index-key */
import { Row, Col } from 'react-bootstrap';

const GroupByLabel = ({ sourceGroupBy, targetGroupBy }) => (
    <Row style={{ marginTop: '1rem' }}>
        <Col>
            <h6>Selected Group by Columns</h6>
            <ul className="true-comply-datarecon__reconcliationtype-sum__list">
                {
                    sourceGroupBy.map((data, index) => <li key={index}>{data}</li>)
                }
            </ul>
        </Col>
        <Col>
            <h6>Selected Group by Columns</h6>
            <ul className="true-comply-datarecon__reconcliationtype-sum__list">
                {
                    targetGroupBy.map((data, index) => <li key={index}>{data}</li>)
                }
            </ul>
        </Col>

    </Row>
);

export default GroupByLabel;
